import { FriendListCoreProps } from "./types"
import React, { useCallback } from "react"
import { SectionList } from "~/ui/primitives"
import FriendListItem from "./components/friend-list-item"
import styled from "~/ui/styled"

const Letter = styled.Text`
  padding: 8px 12px;
  font-size: 13px;
  background-color: ${({ theme }) => theme.colors.background};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};
`

export const FriendListCore: React.FC<FriendListCoreProps> = ({
  sections,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  const keyExtractor = useCallback((item) => item.id.toString(), [])
  const renderItem = useCallback(
    ({ item }) => {
      return (
        <FriendListItem
          friend={item}
          swipeActionButtonConfigs={swipeActionButtonConfigs}
          onItemClick={onItemClick}
          selecteds={selecteds}
        />
      )
    },
    [selecteds, onItemClick],
  )
  const renderSectionHeader = useCallback(
    ({ section: { title, data } }) => (
      <Letter>{data?.length > 0 ? title + `(${data?.length})` : ""}</Letter>
    ),
    [],
  )

  return (
    <SectionList
      sections={sections}
      keyExtractor={keyExtractor}
      renderSectionHeader={renderSectionHeader}
      renderItem={renderItem}
    />
  )
}
